import { BulkActivateButton } from '@/view/employees/EmployeesList/components/BulkActivateButton';
import { BulkTerminateButton } from '@/view/employees/EmployeesList/components/BulkTerminateButton';

interface IBulkActionsProps {
  handleOpenSuspendEmployeesModal: () => void;
}

function BulkActions({ handleOpenSuspendEmployeesModal }: IBulkActionsProps): JSX.Element {
  return (
    <>
      <BulkActivateButton />
      <BulkTerminateButton handleOpenSuspendEmployeesModal={handleOpenSuspendEmployeesModal} />
    </>
  );
}

export default BulkActions;
